import { Injectable , Inject} from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { CompanyDetails } from '../model/company-details.model';
import { Observable, throwError } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class CompanyDetailsService {

  constructor(private httpClient: HttpClient, @Inject('BASE_URL') private baseUrl: string) { }

  GetCompanyDetails(): Observable <CompanyDetails>{
    return this.httpClient.get<CompanyDetails>(this.baseUrl+'/api/CompanyDetails/GetCompanyDetails')
  }
}
